<template>
    <ui5-dialog
        class="input-dialog"
        :header-text="title"
        ref="dialog"
        :modal="false">
        <div class="container">
            <div
                class="message"
                v-if="html"
                v-show="message && message.length > 0"
                v-html="message"></div>
            <div class="message" v-else v-show="message && message.length > 0">
                {{ message }}
            </div>
            <div class="input-container" v-if="type == 'input'">
                <ui5-input
                    :value="inputValue"
                    @input="inputValue = $event.target.value" />
            </div>
            <div class="buttons">
                <ui5-button @click="cancel">{{ cancelButton }}</ui5-button>
                <ui5-button @click="ok">{{ confirmButton }}</ui5-button>
            </div>
        </div>
    </ui5-dialog>
</template>
<script>
let resolve = null;
let reject = null;
export default {
    props: {
        type: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            inputValue: '',
            closeOnCancel: false,
            closeOnOk: false,
            html: false,
            title: '',
            message: '',
            confirmButton: '',
            cancelButton: '',
        };
    },
    methods: {
        show({
            title,
            content,
            html = false,
            closeOnOk = false,
            closeOnCancel = false,
            confirmButton = 'OK',
            cancelButton = 'Annuleren',
        }) {
            this.title = title;
            this.html = html;
            this.message = content;
            this.closeOnCancel = closeOnCancel;
            this.closeOnOk = closeOnOk;
            this.confirmButton = confirmButton;
            this.cancelButton = cancelButton;
            this.inputValue = '';
            this.$refs.dialog.show();
            return new Promise((res, rej) => {
                resolve = res;
                reject = rej;
            });
        },
        cancel() {
            reject(this.$refs.dialog);
            if (this.closeOnCancel) {
                this.$refs.dialog.close();
            }
        },
        ok() {
            if (this.type == 'input') {
                resolve({ dialog: this.$refs.dialog, value: this.inputValue });
            } else {
                resolve(this.$refs.dialog);
            }
            if (this.closeOnOk) {
                this.$refs.dialog.close();
            }
        },
    },
};
</script>
